/*
Controller: Categories

Operations:
  getCategories
*/
var Api = require('../config')

var Categories = (function () {
  /*
  Operation: getCategories
  Query existing categories
  Parameters:
  Responses:
    HTTP 200: List of categories
  */
  function getCategoriesCategories () {
    return new Promise(function (resolve, reject) {
      try {
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var path = '/categories'
      Api
        .request({
          url: path,
          method: 'get'
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  var ret = {}
  ret['getCategories'] = getCategoriesCategories
  return ret
})()

module.exports = Categories
